<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
      <!-- <b-card-text>specialist.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Specialist -->
            <b-col cols="12">
              <b-form-group label="Specialist" label-for="v-specialist">
                <validation-provider #default="{ errors }"  name="Specialist" rules="required">
                  <b-form-input  id="v-specialist-name" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_1" placeholder="Specialist" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Icon -->
            <b-col cols="12">
              <b-form-group label="Icon" label-for="v-icon">
                <validation-provider #default="{ errors }" name="Icon" >
                  <b-form-input id="v-icon" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_2" placeholder="Icon" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Desc -->
            <b-col cols="12">
              <b-form-group label="Desc" label-for="v-desc">
                <validation-provider #default="{ errors }" name="Desc" >
                  <b-form-input id="v-desc" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_3" placeholder="Desc" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- isHighlight -->
            <b-col cols="1">
              <b-form-group label="isHighlight" label-for="v-isHighlight">
                <b-form-checkbox
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  v-model="form.checkbox_4"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="MaximizeIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="MaximizeIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BFormCheckbox, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { BOverlay, ValidationProvider, ValidationObserver, BFormCheckbox, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, text_1: '',text_2: '',text_3: '',checkbox_4: false},
      show: false,
      required 
    }
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('specialist/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('specialist/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.icon
        this.form.text_3 = data.desc
        this.form.checkbox_4 = data.is_highlight === true ? true : false,
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>